const DEFAULT_STATE = {
  select_patient_modal: false,
  selected_patient_id: null,
  patient: {}
}

let changes = null;
export default function quickActionReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {

    case 'QUICK_ACTIONS':
      changes = {
        ...state, ...action.payload
      };
      return { ...state, ...changes };

    case 'QUICK_ACTIONS_RESET':
      changes = {
        ...DEFAULT_STATE
      };
      return { ...state, ...changes };

    default:
      return state;
  }
}